module.exports = __webpack_public_path__ + "static/img/hmc-digital-showroom.1660d1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hmc-digital-showroom.png
// module id = v9V+
// module chunks = 0